import React, { useState } from 'react';
import Modal from '@material-ui/core/Modal';
import {
  Button,
  Checkbox,
  Container,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputLabel,
  ThemeProvider,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { DropzoneArea } from 'material-ui-dropzone';
import { createTheme } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { createArtist, fetchArtists } from 'redux/ducks/artists';
import { sendAlert } from 'redux/ducks/alert';
import { EAlertVariant } from 'interfaces/alert';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
interface IProps {
  onClose: () => void;
  open: boolean;
}

const theme = (createTheme as any)({
  overrides: {
    MuiDropzoneArea: {
      root: {
        minHeight: 'auto'
      },
      text: {
        fontSize: '1rem'
      },
      icon: {
        width: '33px'
      }
    },
    MuiDropzonePreviewList: {
      root: {
        justifyContent: 'center',
        position: 'absolute',
        top: 0
      },
      imageContainer: {
        maxWidth: '100%',
        flexBasis: '100%'
      }
    }
  }
});
const ckEditorToolbarConfig = [
  'Heading',
  '|',
  'bold',
  'italic',
  '|',
  'BulletedList',
  'NumberedList',
  '|',
  'Indent',
  '|',
  'BlockQuote',
  'undo',
  'redo'
];
export default function ModalCreateArtist(props: IProps) {
  const { onClose, open } = props;
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [quote, setQuote] = useState('');
  const [slug, setSlug] = useState('');
  const [slugError, setSlugError] = useState('');
  const [shortDesc, setShortDesc] = useState('');
  const [longDesc, setLongDesc] = useState('');
  const [shortName, setShortName] = useState('');
  const [firstName, setFirstName] = useState(false);
  const [active, setActive] = useState(false);
  const [imageSource, setImageSource] = useState<File>();
  const [clicked, setClicked] = useState(false);
  const [surnameOrderOnly, setSurnameOrderOnly] = useState<string>('');
  const [surnameOrderOnlyError, setSurnameOrderOnlyError] = useState<string>('');
  const [artistImageError, setArtistImageError] = useState('');
  const handleClose = (number: number) => {
    if (number === 1) {
      dispatch(fetchArtists());
    }
    setName('');
    setQuote('');
    setNameError('');
    setSlug('');
    setSlugError('');
    setShortDesc('');
    setLongDesc('');
    setShortName('');
    setFirstName(false);
    setActive(false);
    setImageSource(null);
    setClicked(false);
    onClose();
    setSurnameOrderOnly('');
    setArtistImageError('');
  };

  const handleImage = (event: any) => {
    if (event.length > 0) {
      setImageSource(event[0]);
      setArtistImageError('');
    }
  };

  const checkForm = () => {
    if (!imageSource || name === '' || slug === '' || surnameOrderOnly === '') {
      if (!imageSource) {
        setArtistImageError('Please add the artist image');
      }
      if (name === '') {
        setNameError('Please enter name');
      }
      if (slug === '') {
        setSlugError('Please enter web url');
      }
      if (surnameOrderOnly === '') {
        setSurnameOrderOnlyError('Please add the surname');
      }
      dispatch(sendAlert('Please check the errors below', EAlertVariant.ERROR));
      return false;
    }
    return true;
  };

  const submitCreation = () => {
    if (checkForm()) {
      setClicked(true);
      dispatch(
        createArtist({
          name,
          short_name: shortName,
          short_description: shortDesc,
          image: imageSource,
          slug,
          firstname: firstName,
          long_description: longDesc,
          artist_active: active,
          quote,
          surname_orderonly: surnameOrderOnly
        })
      ).then((result: number) => {
        if (result === 1) {
          handleClose(1);
        } else {
          setClicked(false);
        }
      });
    }
  };

  return (
    <Modal
      className="create-menu-dialog"
      open={open}
      onClose={() => handleClose(0)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className="modal-create-menu-content">
        <IconButton
          style={{ width: '50px' }}
          color="secondary"
          onClick={() => handleClose(0)}
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle id="simple-dialog-title">
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}
          >
            <div>Create Artist</div>
            <div>
              <Button
                onClick={submitCreation}
                variant="outlined"
                color="primary"
                disabled={clicked}
              >
                Save
              </Button>
            </div>
          </div>
        </DialogTitle>
        <Container maxWidth="md">
          <Grid>
            <FormControlLabel
              control={
                <Checkbox
                  checked={active}
                  onChange={() => {
                    setActive(!active);
                  }}
                  name="checkedB"
                  color="primary"
                />
              }
              label="Active"
            />
          </Grid>
          <FormControl
            style={{
              marginTop: '0px'
            }}
            fullWidth={true}
            margin={'normal'}
            error={nameError !== ''}
          >
            <InputLabel htmlFor="name-input">Name</InputLabel>
            <Input
              id="name-input"
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setNameError('');
              }}
            />
            <FormHelperText>{nameError}</FormHelperText>
          </FormControl>
          <FormControl
            style={{
              marginTop: '0px'
            }}
            fullWidth={true}
            margin={'normal'}
          >
            <InputLabel htmlFor="name-input">Short Name</InputLabel>
            <Input
              id="name-input"
              type="text"
              value={shortName}
              onChange={(e) => {
                setShortName(e.target.value);
              }}
            />
          </FormControl>
          <FormControl
            style={{
              marginTop: '0px'
            }}
            fullWidth={true}
            margin={'normal'}
            error={surnameOrderOnlyError !== ''}
          >
            <InputLabel htmlFor="name-input">Surname Orderonly</InputLabel>
            <Input
              id="surnameOrderOnly-input"
              type="text"
              value={surnameOrderOnly}
              onChange={(e) => {
                setSurnameOrderOnly(e.target.value);
              }}
            />
            <FormHelperText>{surnameOrderOnlyError}</FormHelperText>
          </FormControl>
          <Grid>
            <FormControlLabel
              control={
                <Checkbox
                  checked={firstName}
                  onChange={() => {
                    setFirstName(!firstName);
                  }}
                  name="checkedB"
                  color="primary"
                />
              }
              label="First Name"
            />
          </Grid>
          <FormControl
            style={{
              marginTop: '0px'
            }}
            fullWidth={true}
            margin={'normal'}
          >
            <div
              style={{
                fontWeight: 'lighter',
                fontSize: '1.1vw',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: '1vw'
              }}
            >
              Short Description
            </div>
            <CKEditor
              editor={ClassicEditor}
              config={{
                toolbar: ckEditorToolbarConfig
              }}
              data={shortDesc}
              onChange={(event, editor) => {
                const data = editor.getData();
                setShortDesc(data);
              }}
            />
          </FormControl>
          <FormControl
            style={{
              marginTop: '0px'
            }}
            fullWidth={true}
            margin={'normal'}
          >
            <div
              style={{
                fontWeight: 'lighter',
                fontSize: '1.1vw',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: '1vw'
              }}
            >
              Long Description
            </div>
            <CKEditor
              editor={ClassicEditor}
              config={{
                toolbar: ckEditorToolbarConfig
              }}
              data={longDesc}
              onChange={(event, editor) => {
                const data = editor.getData();
                setLongDesc(data);
              }}
            />
          </FormControl>
          <FormControl
            style={{
              marginTop: '0px'
            }}
            fullWidth={true}
            margin={'normal'}
            error={slugError !== ''}
          >
            <InputLabel htmlFor="name-input">Web URL</InputLabel>
            <Input
              id="name-input"
              type="text"
              value={slug}
              onChange={(e) => {
                setSlug(e.target.value);
                setSlugError('');
              }}
            />
            <FormHelperText>{slugError}</FormHelperText>
          </FormControl>{' '}
          <FormControl
            style={{
              marginTop: '0px'
            }}
            fullWidth={true}
            margin={'normal'}
          >

            <div
              style={{
                fontWeight: 'lighter',
                fontSize: '1.1vw',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: '1vw'
              }}
            >
              Quote
            </div>
            <CKEditor
              editor={ClassicEditor}
              config={{
                toolbar: ckEditorToolbarConfig
              }}
              data={quote}
              onChange={(event, editor) => {
                const data = editor.getData();
                setQuote(data);
              }}
            />
          </FormControl>
          <ThemeProvider theme={theme}>
            <DropzoneArea
              acceptedFiles={['image/*']}
              dropzoneText={'Drag and drop the artist image here'}
              onChange={(files) => handleImage(files)}
              filesLimit={1}
            />
            <Typography variant="caption" style={{ color: '#fe309c' }}>
              For better resolution insert images with 1000x1000
            </Typography>
            <br />
            <Typography variant="caption" style={{ color: 'red' }}>
              {artistImageError}
            </Typography>
          </ThemeProvider>
        </Container>
      </div>
    </Modal>
  );
}
